import React, { useState, useEffect } from "react";

import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  FormGroup,
  Breadcrumb,
} from "react-bootstrap";
import { 
  addReasonTemplate, 
  getReasonTemplateById, 
  updateReasonTemplateById 
} from "../../actions/reasonTemplateAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";

import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link } from "react-router-dom";

// Schema for yup
const reasonTemplateSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, "Title must have at least 2 characters")
    .max(100, "Title can't be longer than 100 characters")
    .trim("Spaces are not allowed")
    .required("Title field is required"),
  description: Yup.string()
    .trim("Spaces are not allowed")
    .required("Description field is required"),
});

const EditReasonTemplate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      status: false,
    },
    validationSchema: reasonTemplateSchema,
    onSubmit: async (values) => {
      setLoader(true);
      let res = await updateReasonTemplateById(id, values);
      if (res?.data?.success) {
        navigate("/reason-template");
        toast.success(res.data.message);
      }
      setLoader(false);
    },
  });

  const getReasonTemplateData = async () => {
    setLoader(true);
    let res = await getReasonTemplateById(id);
    if (res?.data?.data) {
      const data = res.data.data;
      formik.setValues({
        title: data.title || "",
        description: data.description || "",
        status: data.status || false,
      });
    }
    setLoader(false);
  };

  useEffect(() => {
    if (id) {
      getReasonTemplateData();
    }
  }, [id]);

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link className="breadcrumb-item" to="/reason-template">
                    No Prescription Reasons
                  </Link>
                  <Breadcrumb.Item active>Edit</Breadcrumb.Item>
                </Breadcrumb> */}
                <h3>Add Content Page</h3>
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Edit No Prescription Reasons
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Form onSubmit={formik.handleSubmit}>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicTitle"
                      >
                        <Form.Label>
                          Title <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          placeholder="Enter title"
                          value={formik.values.title}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.title && formik.errors.title ? (
                          <span
                            className={formik.errors.title ? `` : `d-none`}
                          >
                            <label className="pl-1 text-danger">
                              {formik.errors.title}
                            </label>
                          </span>
                        ) : null}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="formBasicDescription"
                      >
                        <Form.Label>
                          Description <span className="text-danger">*</span>
                        </Form.Label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={
                            formik.values.description
                              ? formik.values.description
                              : ""
                          }
                          content={
                            formik.values.description
                              ? formik.values.description
                              : ""
                          }
                          onChange={(event, editor) =>
                            formik.setFieldValue(
                              "description",
                              editor.getData()
                            )
                          }
                        />
                        {formik.touched.description && formik.errors.description ? (
                          <span
                            className={
                              formik.errors.description ? `` : `d-none`
                            }
                          >
                            <label className="pl-1 text-danger">
                              {formik.errors.description}
                            </label>
                          </span>
                        ) : null}
                      </Form.Group>

                      <FormGroup>
                        <>
                          <Col className="pl-0">
                            <label className="label-font">Status</label>
                          </Col>
                          <Col
                            
                            className="check-inline d-flex mt-3 flex-column pl-0"
                          >
                            <label className="right-label-radio mr-3 mb-2">
                              Active
                              <input
                                name="status"
                                className="status"
                                checked={formik.values.status}
                                value={formik.values.status}
                                type="radio"
                                onChange={(e) =>
                                  formik.setFieldValue("status", true)
                                }
                              />
                              <span className="checkmark"></span>
                            </label>

                            <label className="right-label-radio mr-3 mb-2">
                              Inactive
                              <input
                                name="status1"
                                className="status"
                                checked={!formik.values.status}
                                value={!formik.values.status}
                                type="radio"
                                onChange={(e) =>
                                  formik.setFieldValue("status", false)
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </Col>
                        </>
                      </FormGroup>
                      <Button className="btn-filled" type="submit">
                        Update
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default EditReasonTemplate;
